import { computed } from 'vue'

export const useCampaignSchedule = () => {
	const startDate = import.meta.env.VITE_CAMPAIGN_START_DATE
	const endDate = import.meta.env.VITE_CAMPAIGN_END_DATE

	if (!startDate || !endDate) {
		return {
			showCampaign: computed(() => false),
			hasCamapaignEnded: computed(() => false),
		}
	}

	const campaignStartDate = new Date(startDate)
	const campaignEndDate = new Date(endDate)

	const showCampaign = computed(() => {
		const now = new Date()
		return now >= campaignStartDate && now <= campaignEndDate
	})

	const hasCampaignEnded = computed(() => {
		const now = new Date()
		return now >= campaignEndDate
	})

	return { showCampaign, hasCampaignEnded }
}
